import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import type { FileDTO } from '@app-libs/model';
import { ApiClient } from '../client/api-client';
import { ConfigurationClientService } from '../client/configuration-client.service';

@Injectable({
  providedIn: 'root',
})
export class FilesApiService extends ApiClient {
  override get baseUrl(): string {
    return this.config.getBackendAPIUrl() + '/files';
  }

  constructor(
    override config: ConfigurationClientService,
    override http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Create a new file entry.
   * @param file Partial file DTO representing the file data to be created.
   * @returns Observable of the created FileDTO.
   */
  createFile(file: Partial<FileDTO>): Observable<FileDTO> {
    const url = `${this.baseUrl}/create`;
    return this.http.post<FileDTO>(url, file);
  }

  /**
   * Get a file by its ID.
   * @param fileId The ID of the file to retrieve.
   * @returns Observable of the FileDTO or null if not found.
   */
  getFileById(fileId: string): Observable<FileDTO | null> {
    const url = `${this.baseUrl}/${fileId}`;
    return this.http.get<FileDTO | null>(url);
  }
}
